import React from 'react'
import { config } from 'config'
import { rhythm } from 'utils/typography'
import { prefixLink } from 'gatsby-helpers'
import profilePic from './profile-pic.jpeg'

import Avatar from 'material-ui/Avatar';
import Octicon from 'react-octicon'

class Bio extends React.Component {
  render() {
    return (
      <div>
        <p
          style={{
            marginBottom: rhythm(2.5),
          }}
        >
          <Avatar size={60} src={prefixLink(profilePic)} alt={`author ${config.authorName}`}
            style={{
              float: 'left'
            }}
          />

          Written by <strong>{config.authorName}</strong> who lives and works in Hong Kong.
          <br />
          Focusing on DevOps, Cloud Services, Microservices etc.

          Find me at <a className="href" href="https://github.com/gankkank"><Octicon className="href" mega name="octoface"/></a>
          
        </p>
      </div>
    )
  }
}

export default Bio


// WEBPACK FOOTER //
// ../components/Bio.js